import React, { useState } from 'react';
import './FocusTimePicker.css';

const FOCUS_PRESETS = [15, 25, 30, 45, 60];

// Duration picker for starting a Focus Mode session. `label` is the todo/habit
// text shown for context; `onStart(mins)` fires when the user confirms.
export default function FocusTimePicker({ label, onStart, onClose }) {
  const [mins, setMins] = useState(25);
  const [custom, setCustom] = useState('');
  const chosen = custom ? parseInt(custom, 10) : mins;
  return (
    <div className="pe-focus-overlay" onMouseDown={onClose}>
      <div className="pe-focus-picker" onMouseDown={e => e.stopPropagation()}>
        <div className="pe-focus-picker-title">⚡ Focus mode</div>
        <div className="pe-focus-picker-todo">{label.length > 70 ? label.slice(0, 70) + '…' : label}</div>
        <div className="pe-focus-picker-label">Set a timer</div>
        <div className="pe-focus-presets">
          {FOCUS_PRESETS.map(p => (
            <button
              key={p}
              className={`pe-focus-preset${!custom && mins === p ? ' pe-focus-preset--on' : ''}`}
              onClick={() => { setMins(p); setCustom(''); }}
            >{p} min</button>
          ))}
        </div>
        <input
          className="pe-focus-custom"
          type="number"
          min="1" max="240"
          placeholder="Custom (mins)"
          value={custom}
          onChange={e => setCustom(e.target.value)}
        />
        <div className="pe-focus-picker-actions">
          <button className="pe-focus-cancel" onClick={onClose}>Cancel</button>
          <button
            className="pe-focus-start"
            disabled={!chosen || chosen < 1}
            onClick={() => onStart(chosen)}
          >Start</button>
        </div>
      </div>
    </div>
  );
}
